module.exports = __webpack_public_path__ + "img/icon_aside_word3_active.ed33debd.svg";